/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from "axios";

import { VApplication } from "../application/index";
import { DeviceInfoService } from "./device-info.service";

const SERVICE_NAME = "contactUs-rest.service";
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require("is_js");

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync("services.DeviceInfoService") as DeviceInfoService;
};

export class ContactUsRestService {
    name = SERVICE_NAME;
    private static instance: ContactUsRestService;

    private api: AxiosInstance;

    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();
        this.api = axios.create({
            baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any = {}) {
        if (!this.instance) {
            this.instance = new ContactUsRestService(props);
        }
        return this.instance;
    }
    async init() {}

    async contactMail({ name, email, subject, message }: { name: string; email: string; subject: string; message: string; }) {
        try {
            log?.info(SERVICE_NAME, "name : ", name);
            if (
                is.not.existy(name) ||
                is.not.string(name) ||
                is.empty(name)
            ) {
                throw Error(`name cannot be null or empty`);
            }
            if (
                is.not.existy(email) ||
                is.not.string(email) ||
                is.empty(email)
            ) {
                throw Error(`email cannot be null or empty`);
            }
            if (
                is.not.existy(subject) ||
                is.not.string(subject) ||
                is.empty(subject)
            ) {
                throw Error(`subject cannot be null or empty`);
            }
            if (
                is.not.existy(message) ||
                is.not.string(message) ||
                is.empty(message)
            ) {
                throw Error(`message cannot be null or empty`);
            }
            const data = {
                "name": name,
                "email": email,
                "subject": subject,
                "message": message,
                "fromUrl": window.location.origin
            };
            const res = await this.api.post(`/contact/mail`, JSON.stringify(data));
            log.info(`contactMail`, res?.data);
            return res;
        } catch (err) {
            log?.error("Error in contactMail", err?.message);
            throw Error(err?.message);
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
